import { Button, Col, Divider, Dropdown, Form, FormInstance, Row, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";

import ComponentePermissao from "../../../Base/Permissao/ComponentePermissao";
import ContaSelect from "../Conta/ContaSelect";
import OrigemSelect from "./Origem/OrigemSelect";
import PessoaSelect from "../../Pessoa/PessoaSelect";
import Titulo, { EnumTituloTipo } from "../../../../Models/Financeiro/Titulo/Titulo";
import TituloSituacaoSelect from "./TituloSituacao/TituloSituacaoSelect";
import TituloTable, { ITituloTableFiltros } from "./TituloTable";

import { useBoletoGerarLoteRemessa } from "../../../../Services/Financeiro/Titulo/Pagamento/BoletoServices";
import BoletoImportarRetornoFormModal from "./Pagamento/Boleto/BoletoImportarRetornoFormModal";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import TituloFormDrawer from "./TituloFormDrawer";
import { IDrawerBasicRef } from "@/Components/Base/Drawer/DrawerBasic";
import { ITituloAReceberScreenProps } from "./TituloAReceberScreen";
import { EnumPessoaTipo } from "@/Models/Pessoa/Pessoa";
import TituloService from "@/Services/Financeiro/Titulo/TituloService";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
export interface ITituloConsultaScreenForm extends FormInstance<ITituloTableFiltros> {

}

export interface ITituloConsultaScreenProps {
    /** @default true */
    defaultFilters?: {
        ativo?: boolean;
        titulo?: Titulo;
    };
    exibirCamposFiltro?: boolean;
    /** @default true */
    exibirCampoOrigem?: boolean;
    formCadastroProps?: ITituloAReceberScreenProps;
    /** @deprecated */
    opcoes?:Array<"adicionar-apagar"|"adicionar-areceber">,
    receita?:boolean;
}

export default function TituloConsultaScreen(
    { 
        exibirCamposFiltro, 
        exibirCampoOrigem, 
        defaultFilters, 
        formCadastroProps,
        receita
    }: ITituloConsultaScreenProps
): JSX.Element {
    receita = receita ?? false;
    exibirCamposFiltro = exibirCamposFiltro ?? true;
    exibirCampoOrigem = exibirCampoOrigem ?? true;
    defaultFilters = defaultFilters ?? {
        titulo: {} as Titulo<any>,
        ativo: true,
    };

    defaultFilters.titulo = defaultFilters.titulo ?? ({} as Titulo);
    defaultFilters.ativo = defaultFilters.ativo ?? true;
    //defaultFilters.titulo.codTipo = (defaultFilters.titulo.codFatura ?? 0) > 0 ? EnumTituloTipo.Parcela : EnumTituloTipo.Titulo;
    defaultFilters.titulo.codTipo = (defaultFilters.titulo.codFatura ?? 0) > 0 ? EnumTituloTipo.Parcela : EnumTituloTipo.Parcela;

    const refDrawerTitulo = useRef<IDrawerBasicRef|null>(null);

    const navigate = useNavigate();

    const [codTituloEdicao, setCodTituloEdicao] = useState(0);
    const [codTituloTipoEdicao, setCodTituloTipoEdicao] = useState(EnumTituloTipo.Parcela);
    
    const [titulosSelecionados, setTitulosSelecionados] = useState<Array<number>>([]);
    const [form] = Form.useForm<ITituloTableFiltros>();
    const [codContaRemessa, setCodContaRemessa] = useState<number|undefined>(undefined);
    const codDevedorForm = Form.useWatch(["titulo", "codDevedor"], form);
    const codBeneficiarioForm = Form.useWatch(["titulo", "codBeneficiario"], form);
    const filtros = Form.useWatch([], form);

    const { mutate, isPending } = useBoletoGerarLoteRemessa({
        onSuccess(response) {
            const elementoA = document.createElement("a");
            document.body.appendChild(elementoA);
            elementoA.id = "linkDownloadArquivo";
            elementoA.style.display = "none";
            //elementoA.style = "display: none";
            const contentDisposition = Object.fromEntries(
                ((response.headers["content-disposition"] as string) ?? (response.headers["Content-Disposition"] as string))
                    .split(";")
                    .map((grupo) => [grupo.split("=")[0]?.trim(), grupo.split("=")[1]?.trim()])
            );
            const url = window.URL.createObjectURL(response.data);

            elementoA.href = url;
            elementoA.download = contentDisposition["filename"];
            elementoA.click();

            document.body.removeChild(elementoA);
        },
    });

    const queryResult = TituloService.useListarPagina({
        pagina : filtros?.pagina ?? new PaginaInfo(),
        titulo: filtros?.titulo,
        ativo: filtros?.ativo,
        receita: receita,
        enabled: true,
        onFinish() {
            setTitulosSelecionados([])
        },
    });

    const {
       refetch 
    } = queryResult;

    useEffect(() => {
        console.log("Rodou limpeza.");
        console.log("Dados: ", form.getFieldsValue());
        form.resetFields();
    }, []);

    return <>
        {/* {process.env.NODE_ENV === "development" && <pre>{JSON.stringify(formCadastroProps, null, 4)}</pre>} */}
        <TituloFormDrawer 
            ref={refDrawerTitulo}
            acao={"alterar"}
            codTituloTipo={codTituloTipoEdicao}
            formProps={{
                ...(formCadastroProps ?? {}),
                codigo : codTituloEdicao,
                onSalvarSucesso : () => {
                    form.setFieldValue(["pagina", "pagina"], 1);
                    refetch();
                }
            }}
        >
            <></>
        </TituloFormDrawer>
        <Form<ITituloTableFiltros>
            layout="vertical"
            autoComplete="off"
            size="small"
            form={form}
            onFinish={() => {
                form.setFieldValue(["pagina", "pagina"], 1);
                refetch();
            }}
            initialValues={{
                ...defaultFilters,
                receita : receita,
                pagina : new PaginaInfo()
            }}
        >
            <Form.Item<ITituloTableFiltros> hidden name={["receita"]}></Form.Item>
            <Form.Item<ITituloTableFiltros> hidden name={["titulo", "codFatura"]}></Form.Item>
            <Form.Item<ITituloTableFiltros> hidden name={["titulo", "codTipo"]}></Form.Item>
            <Form.Item<ITituloTableFiltros> hidden name={["ativo"]}></Form.Item>
            <Form.Item<ITituloTableFiltros> hidden name={["pagina"]}></Form.Item>

            <Row gutter={8} wrap>
                {(defaultFilters.titulo.codFatura ?? 0) === 0 && <Col xs={24} sm={12} md={8} lg={4}>
                    <Form.Item<ITituloTableFiltros> label="Tipo" name={["titulo", "codTipo"]}>
                        <Select
                            placeholder="Selecione"
                            allowClear
                            options={[
                                { value: 1, label: "Título" },
                                { value: 2, label: "Parcela" }
                            ]}
                        />
                    </Form.Item>
                </Col>}
            
                {exibirCamposFiltro && (
                    <>
                        <Form.Item<ITituloTableFiltros> hidden name={["titulo", "origem"]}></Form.Item>
                    
                        <Col xs={24} md={12} lg={10}>
                            <PessoaSelect<ITituloTableFiltros>
                                tiposPessoaValidos={receita ? [EnumPessoaTipo.EMPRESA] : undefined}
                                tiposPessoaInValidos={receita ? undefined : [EnumPessoaTipo.EMPRESA]}
                                placeholder="Beneficiário"
                                placeholderTipo="Tipo beneficiário"
                                names={{
                                    "*": ["titulo", "codBeneficiario"],
                                    tipo: ["titulo", "beneficiario", "tipo"],
                                }}
                            />
                        </Col>
                        
                        <Col xs={24} md={12} lg={10}>
                            <PessoaSelect<ITituloTableFiltros>
                                tiposPessoaValidos={receita ? undefined : [EnumPessoaTipo.EMPRESA]}
                                tiposPessoaInValidos={receita ? [EnumPessoaTipo.EMPRESA] : undefined}
                                placeholder="Devedor"
                                placeholderTipo="Tipo devedor"
                                names={{
                                    "*": ["titulo", "codDevedor"],
                                    tipo: ["titulo", "devedor", "tipo"],
                                }}
                            />
                        </Col>

                        <Col xs={24} sm={12} md={8} lg={4}>
                            <Form.Item<ITituloTableFiltros> label="Situação" name={["titulo", "codSituacao"]}>
                                <TituloSituacaoSelect />
                            </Form.Item>
                        </Col>                        

                        {exibirCampoOrigem && (
                            <Col xs={24}>
                                <OrigemSelect<ITituloTableFiltros>
                                    names={{
                                        codTipo: ["titulo", "origem", "codTipo"],
                                        codReferencia: ["titulo", "origem", "codReferencia"],
                                    }}
                                    inscricaoProps={{
                                        codResponsavel : receita ? codDevedorForm : codBeneficiarioForm
                                    }}
                                />
                            </Col>
                        )}
                    </>
                )}
            </Row>

            <Row gutter={[8, 8]} wrap style={{ marginBottom : 8 }}>
                <Col xs={"auto"}>
                    <Button type="primary" htmlType="submit">
                        Listar
                    </Button>
                </Col>

                {
                    receita && 
                    <ComponentePermissao permissoes={["FinanceiroTituloInserirAReceber"]}>
                        <Col xs={"auto"}>
                            {(formCadastroProps?.aReceberProps?.defaultValues?.codFatura ?? 0) > 0 && <TituloFormDrawer 
                                acao="adicionar-receber" 
                                codTituloTipo={EnumTituloTipo.Parcela} 
                                formProps={{
                                    ...(formCadastroProps ?? {}),
                                    onSalvarSucesso : (...e) => {
                                        form.setFieldValue(["pagina", "pagina"], 1);
                                        refetch();
                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                    }
                                }}
                            >
                                <Button type="primary" size="small">+ Parcela</Button>
                            </TituloFormDrawer> || <TituloFormDrawer 
                                acao="adicionar-receber" 
                                codTituloTipo={EnumTituloTipo.Titulo} 
                                formProps={{
                                    ...(formCadastroProps ?? {}),
                                    onSalvarSucesso : (...e) => {
                                        form.setFieldValue(["pagina", "pagina"], 1);
                                        refetch();
                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                    }
                                }}
                            >
                                <Button 
                                    type="primary" 
                                    size="small"
                                    // style={{
                                    //     width: "100%",
                                    //     height: "100%"
                                    // }}
                                >+ Lançamento</Button>
                            </TituloFormDrawer>}
                            {/* {(formCadastroProps?.aReceberProps?.defaultValues?.codFatura ?? 0) > 0 && <TituloFormDrawer 
                                acao="adicionar-receber" 
                                codTituloTipo={EnumTituloTipo.Parcela} 
                                formProps={{
                                    ...(formCadastroProps ?? {}),
                                    onSalvarSucesso : (...e) => {
                                        form.setFieldValue(["pagina", "pagina"], 1);
                                        refetch();
                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                    }
                                }}
                            >
                                <Button type="primary" size="small">+ Parcela</Button>
                            </TituloFormDrawer> || <Dropdown
                                menu={{
                                    items : [
                                        {
                                            key : 1,
                                            label : <TituloFormDrawer 
                                                acao="adicionar-receber" 
                                                codTituloTipo={EnumTituloTipo.Titulo} 
                                                formProps={{
                                                    ...(formCadastroProps ?? {}),
                                                    onSalvarSucesso : (...e) => {
                                                        form.setFieldValue(["pagina", "pagina"], 1);
                                                        refetch();
                                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                                    }
                                                }}
                                            >
                                                <Button 
                                                    type="primary" 
                                                    size="small"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%"
                                                    }}
                                                >+ Título</Button>
                                            </TituloFormDrawer>
                                        },
                                        {
                                            key : 2,
                                            label : <TituloFormDrawer 
                                                acao="adicionar-receber" 
                                                codTituloTipo={EnumTituloTipo.Parcela} 
                                                formProps={{
                                                    ...(formCadastroProps ?? {}),
                                                    onSalvarSucesso : (...e) => {
                                                        form.setFieldValue(["pagina", "pagina"], 1);
                                                        refetch();
                                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                                    }
                                                }}
                                            >
                                                <Button 
                                                    type="primary"
                                                    size="small"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%"
                                                    }}
                                                >+ Parcela</Button>
                                            </TituloFormDrawer>
                                        }
                                    ]
                                }}
                            >
                                <Button type="primary" size="small">+ A receber</Button>
                            </Dropdown>} */}
                        </Col>
                    </ComponentePermissao>
                }
                
                {
                    !receita && <ComponentePermissao permissoes={["FinanceiroTituloInserirAPagar"]}>
                        <Col xs={"auto"}>
                            {(formCadastroProps?.aPagarProps?.defaultValues?.codFatura ?? 0) > 0 && <TituloFormDrawer 
                                acao="adicionar-pagar" 
                                codTituloTipo={EnumTituloTipo.Parcela} 
                                formProps={{
                                    ...(formCadastroProps ?? {}),
                                    onSalvarSucesso : (...e) => {
                                        form.setFieldValue(["pagina", "pagina"], 1);
                                        refetch();
                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                    }
                                }}
                            >
                                <Button type="primary" size="small" danger>+ Parcela</Button>
                            </TituloFormDrawer> || <TituloFormDrawer 
                                acao="adicionar-pagar" 
                                codTituloTipo={EnumTituloTipo.Titulo} 
                                formProps={{
                                    ...(formCadastroProps ?? {}),
                                    onSalvarSucesso : (...e) => {
                                        form.setFieldValue(["pagina", "pagina"], 1);
                                        refetch();
                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                    }
                                }}
                            >
                                <Button 
                                    type="primary" 
                                    danger
                                    size="small"
                                    // style={{
                                    //     width: "100%",
                                    //     height: "100%"
                                    // }}
                                >+ Lançamento</Button>
                            </TituloFormDrawer>}
                            
                            {/*<Dropdown
                                menu={{
                                    items : [
                                        {
                                            key : 1,
                                            label : <TituloFormDrawer 
                                                acao="adicionar-pagar" 
                                                codTituloTipo={EnumTituloTipo.Titulo} 
                                                formProps={{
                                                    ...(formCadastroProps ?? {}),
                                                    onSalvarSucesso : (...e) => {
                                                        form.setFieldValue(["pagina", "pagina"], 1);
                                                        refetch();
                                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                                    }
                                                }}
                                            >
                                                <Button 
                                                    type="primary" 
                                                    danger 
                                                    style={{
                                                        width: "100%",
                                                        height: "100%"
                                                    }}
                                                >+ Título</Button>
                                            </TituloFormDrawer>
                                        },
                                        {
                                            key : 2,
                                            label : <TituloFormDrawer 
                                                acao="adicionar-pagar" 
                                                codTituloTipo={EnumTituloTipo.Parcela} 
                                                formProps={{
                                                    ...(formCadastroProps ?? {}),
                                                    onSalvarSucesso : (...e) => {
                                                        form.setFieldValue(["pagina", "pagina"], 1);
                                                        refetch();
                                                        formCadastroProps?.onSalvarSucesso?.(...e);
                                                    }
                                                }}
                                            >
                                                <Button 
                                                    type="primary" 
                                                    danger 
                                                    style={{
                                                        width: "100%",
                                                        height: "100%"
                                                    }}
                                                >+ Parcela</Button>
                                            </TituloFormDrawer>
                                        }
                                    ]
                                }}
                            >
                                <Button type="primary" danger>+ A pagar</Button>
                            </Dropdown>*/}
                        </Col>
                    </ComponentePermissao>
                }

                <Col xs={"auto"}>
                    <BoletoImportarRetornoFormModal propsButtonOpen={{ size : "small" }} textButtonOpen={"Importar retorno"} />
                </Col>
            </Row>

            {titulosSelecionados.length > 0 && (
                <Row gutter={8} wrap>
                    <Divider orientation="left">Remessa</Divider>
                    <Col xs={"auto"}>
                        <ContaSelect 
                            onChange={(v) => setCodContaRemessa(typeof v === "number" || v === undefined ? v : Number.parseInt(v))}
                            value={codContaRemessa}
                            filtros={{
                                encerrada : false,
                                codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                            }}
                        />
                    </Col>
                    <Col xs={"auto"}>
                        <Button
                            type="primary"
                            loading={isPending}
                            onClick={() => {
                                mutate({
                                    titulos: titulosSelecionados,
                                    codConta: codContaRemessa as number,
                                });
                            }}
                        >
                            Gerar remessa
                        </Button>
                    </Col>
                </Row>
            )}

            <ComponentePermissao permissoes={["FinanceiroTituloListar"]}>
                <TituloTable 
                    rowSelection={{
                        type : "checkbox",
                        hideSelectAll : true,
                        selectedRowKeys : titulosSelecionados,
                        onChange(selectedRowKeys, selectedRows, info) {
                            setTitulosSelecionados(selectedRowKeys as Array<number>);
                        }
                    }}
                    size={"small"}
                    queryResult={queryResult}
                    filtros={[{
                        ...filtros,
                        receita : receita
                    }, (values) => {
                        form.setFieldsValue({
                            ///...filtros,
                            ...(values ?? {}),
                            receita : receita
                        } as any);
                    }]}
                    onEditar={({codigo, codTipo}) => {
                        setCodTituloEdicao(codigo);
                        setCodTituloTipoEdicao(codTipo);
                        refDrawerTitulo.current?.abrir();
                    }}
                    onVisualizar={({codigo}) => {
                        navigate(`../visualizar/${codigo}`)
                    }}
                />
            </ComponentePermissao>
        </Form>
    </>;
}
